<section *ngIf="contentLoaded" class="landing-avvc-page-container">
	<!-- Page Content -->
	<div class="page-content container-fluid">
		<section class="section-avvc">
			<!-- Section entête -->
			<section class="avvc-entete">
				<h1>{{bandeauContenu.title}}</h1>
				<p class="mat-body-2">{{bandeauContenu.description}}</p>
				<ul>
					<li *ngFor="let atout of bandeauContenu.listeAtouts">
						<mat-icon [svgIcon]="atout.icon"></mat-icon>
						<p class="body-lg">{{atout.description}}</p>
					</li>
				</ul>
				<dd1pnds-ng-button backgroundColor="blue" [buttonContent]="bandeauContenu.boutonLibelle"
				(buttonClicked)="goToFormulaireEligibilite()"></dd1pnds-ng-button>
			</section>

			<!-- Section d'information sur la discrètion de la procédure -->
			<section class="avvc-procedure-discrete">
				<h4>{{bandeauContenu.miseEnAvant.titre}}</h4>
				<p *ngFor="let texte of bandeauContenu.miseEnAvant.description" class="body-lg" [innerHtml]="texte"></p>
				<dd1pnds-ng-link-v2 [isDisplayedMatIconLeft]="false" [linkLabel]="bandeauContenu.miseEnAvant.lien.label"
					(linkClicked)="redirectToPage(bandeauContenu.miseEnAvant.lien.url, eventsStats.clicEffacerTraces)"
					class="body-lg">
				</dd1pnds-ng-link-v2>
			</section>

			<!-- Section FAQ, contenue dans plusieurs expansion panels -->
			<section class="avvc-faq-panel">
				<!-- L'accordéon contenant les informations sur Qu'appelle-t-on des “violences conjugales” ? -->
				<mat-expansion-panel *ngIf="faqContent.violencesConjugales as faqItem" class="mat-elevation-z"
				 	(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>
				<!-- L'accordéon contenant les informations sur En quoi consiste cette aide ? -->
				<mat-expansion-panel *ngIf="faqContent.aide as faqItem" class="mat-elevation-z"
				(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>
				<!-- L'accordéon contenant les informations sur Dans le cas d'un prêt ? -->
				<mat-expansion-panel *ngIf="faqContent.pretModalites as faqItem" class="mat-elevation-z"
				(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>
				<!-- L'accordéon contenant les informations sur Qui peut bénéficier de cette aide ? -->
				<mat-expansion-panel #accordeonQuiPeutBeneficierAvvc *ngIf="faqContent.beneficier as faqItem"
					class="mat-elevation-z" (opened)="sendClickStat(faqItem.clickStat)" [(expanded)]="isFaqBeneficierExpanded[0]">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>
				<!-- L'accordéon contenant les informations sur Quel justificatif est nécessaire ? -->
				<mat-expansion-panel *ngIf="faqContent.justificatif as faqItem" class="mat-elevation-z"
					(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>

				<!-- L'accordéon contenant le formulaire permettant de calculer le montant de l'aide aux victimes de
				violence conjugale en fonction de ses revenus et du nombre d'enfants dont on a la charge -->
				<mat-expansion-panel *ngIf="faqContent.montant as faqItem" class="mat-elevation-z"
				(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<p *ngFor="let texte of faqItem.reponses[0].contenu" [innerHtml]="texte"></p>
					<form *ngIf="faqItem.reponses[1] as faqContent" class="avvc-faq-form" [formGroup]="faqContent.formGroup">
						<ng-container *ngFor="let field of faqContent.contenu | keyvalue : sortOrder">
							<ng-container *ngIf="field.key === 'combienEnfants' || field.key === 'combienSalaire'">
								<div class="field-info">
									<p [id]="field.value.nomHtml + '-label'"
									   [class.field-info-error]="isBoutonCalculMontantClique && faqContent.formGroup.controls[field.key].invalid">

										{{field.value.titre}}
									</p>
									<div [id]="field.value.nomHtml + '-detail'" class="petite-ligne">
										<dd1pnds-ng-faq-content [faqItems]="field.value.description">
										</dd1pnds-ng-faq-content>
									</div>
								</div>
								<mat-radio-group class="colonne" [name]="field.value.nomHtml"
									[formControlName]="field.key" [attr.aria-labelledby]="field.value.nomHtml + '-label'"
									[attr.aria-describedby]="field.value.nomHtml + '-detail'">
									<mat-radio-button *ngFor="let choice of field.value.choices" [value]="choice.value">
										<p>
											{{choice.label.principal}}
										</p>
										<p *ngIf="choice.label.secondaire" class="petite-ligne">
											{{choice.label.secondaire}}
										</p>
									</mat-radio-button>
								</mat-radio-group>
								<div *ngIf="isBoutonCalculMontantClique && faqContent.formGroup.controls[field.key].errors?.required"
									class="field-info-error">
									{{field.value.erreurs.required}}
								</div>
							</ng-container>

							<ng-container *ngIf="field.key === 'nbEnfants'
								&& faqContent.formGroup.controls[field.key].enabled">
								<div class="field-info">
									<p [id]="field.value.nomHtml + '-label'"
									   [class.field-info-error]="(isBoutonCalculMontantClique || faqContent.formGroup.controls[field.key].dirty) && faqContent.formGroup.controls[field.key].invalid">

										{{field.value.titre}}
									</p>
									<div [id]="field.value.nomHtml + '-detail'" class="petite-ligne">
										<dd1pnds-ng-faq-content [faqItems]="field.value.description">
										</dd1pnds-ng-faq-content>
									</div>
								</div>
								<input type="text" class="font-regular input-nb-enfants"
									inputmode="numeric" (change)="onChangeNbEnfants($event.target.value)"
									[name]="field.value.nomHtml" [formControlName]="field.key"
									[attr.aria-labelledby]="field.value.nomHtml + '-label'"
									[attr.aria-describedby]="field.value.nomHtml + '-detail'" />
								<div *ngIf="(isBoutonCalculMontantClique || faqContent.formGroup.controls[field.key].dirty) && faqContent.formGroup.controls[field.key].invalid"
									class="field-info-error">
									{{field.value.erreurs.required}}
								</div>
							</ng-container>
						</ng-container>

						<dd1pnds-ng-button backgroundColor="blue" [buttonContent]="faqContent.boutonLibelle"
							(buttonClicked)="onClickCalculerMontantButton()"></dd1pnds-ng-button>

						<dd1pnds-ng-banner *ngIf="displayAlerteMontantAvvc" [bannerContent]="alerteMontantAvvc">
						</dd1pnds-ng-banner>
					</form>
				</mat-expansion-panel>

				<!-- L'accordéon contenant les informations sur Est-ce que cette aide est imposable ? -->
				<mat-expansion-panel *ngIf="faqContent.imposabilite as faqItem" class="mat-elevation-z"
					(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>
				<!-- L'accordéon contenant les informations sur Comment se déroule la demande ? -->
				<mat-expansion-panel *ngIf="faqContent.demande as faqItem" class="mat-elevation-z"
					(opened)="sendClickStat(faqItem.clickStat)">
					<mat-expansion-panel-header class="ligne-bleue">
						<mat-panel-title>{{faqItem.titre}}</mat-panel-title>
					</mat-expansion-panel-header>
					<dd1pnds-ng-faq-content [faqItems]="faqItem.reponses"></dd1pnds-ng-faq-content>
				</mat-expansion-panel>
			</section>

			<!-- Formulaire pour déterminer l'éligibilité à l'Aide aux Victimes de Violence Conjugale (AVVC) -->
			<section #sectionFormulaireEligibilite class="avvc-eligibilite-panel">
				<h3>{{eligibiliteAvvcContent.titre}}</h3>
				<p>{{eligibiliteAvvcContent.sousTitre}}</p>
				<p class="petite-ligne">{{eligibiliteAvvcContent.precision}}</p>
				<form [formGroup]="eligibiliteAvvcForm">

					<!-- Question sur le lieu de résidence de la victime -->
					<ng-container *ngIf="eligibiliteAvvcContent.questions.residence as field">
						<div [id]="field.htmlName + '-label'" class="radio-group-description">
							<p *ngFor="let line of field.titre">{{line}}</p>
						</div>
						<mat-radio-group [ngClass]="field.style" [name]="field.htmlName"
							(change)="onChangeResidenceSendStat($event.value)" [formControlName]="field.controlName"
							[attr.aria-labelledby]="field.htmlName + '-label'">
							<mat-radio-button *ngFor="let choice of field.choices" [value]="choice.value">
								{{choice.label}}
							</mat-radio-button>
						</mat-radio-group>
						<dd1pnds-ng-banner *ngIf="eligibiliteAvvcForm.value.residence === false"
							[bannerContent]="field.bannerContent"
							(linkClicked)="scrollIntoAndOpenAccordeon(accordeonBeneficiaire, isFaqBeneficierExpanded)">
						</dd1pnds-ng-banner>
					</ng-container>

					<!-- Question sur le statut de séjour de la victime : français, ressortissant de l'UE, etc. -->
					<ng-container *ngIf="eligibiliteAvvcForm.controls.statut.enabled && eligibiliteAvvcContent.questions.statut as field">
						<div [id]="field.htmlName + '-label'" class="radio-group-description">
							<p *ngFor="let line of field.titre">{{line}}</p>
						</div>
						<mat-radio-group [ngClass]="field.style" [name]="field.htmlName"
						(change)="onChangeStatutSendStat($event.value)" [formControlName]="field.controlName"
						[attr.aria-labelledby]="field.htmlName + '-label'">
							<mat-radio-button *ngFor="let choice of field.choices" [value]="choice.value">
								{{choice.label}}
							</mat-radio-button>
						</mat-radio-group>
						<dd1pnds-ng-banner *ngIf="eligibiliteAvvcForm.value.statut === false"
							[bannerContent]="field.bannerContent"
							(linkClicked)="scrollIntoAndOpenAccordeon(accordeonBeneficiaire, isFaqBeneficierExpanded)">
						</dd1pnds-ng-banner>
					</ng-container>

					<!-- Question sur la possession par la victime d'un justificatif attestant des violences -->
					<ng-container *ngIf="eligibiliteAvvcForm.controls.justificatif.enabled && eligibiliteAvvcContent.questions.justificatif as field">
						<div [id]="field.htmlName + '-label'" class="radio-group-description">
							<p *ngFor="let line of field.titre">{{line}}</p>
						</div>
						<mat-radio-group [ngClass]="field.style" [name]="field.htmlName"
						(change)="onChangeJustificatifSendStat($event.value)" [formControlName]="field.controlName"
						[attr.aria-labelledby]="field.htmlName + '-label'">
							<mat-radio-button *ngFor="let choice of field.choices" [value]="choice.value">
								{{choice.label}}
							</mat-radio-button>
						</mat-radio-group>
						<dd1pnds-ng-banner *ngIf="eligibiliteAvvcForm.value.justificatif === false"
							[bannerContent]="field.bannerContent" (linkClicked)="redirectToPage($event)">
						</dd1pnds-ng-banner>
					</ng-container>

					<!-- Question sur l'organisme social dont dépend la victime -->
					<ng-container *ngIf="eligibiliteAvvcForm.controls.organisme.enabled && eligibiliteAvvcContent.questions.organisme as field">
						<div [id]="field.htmlName + '-label'" class="radio-group-description">
							<p *ngFor="let line of field.titre">{{line}}</p>
						</div>
						<mat-radio-group [ngClass]="field.style" [name]="field.htmlName"
							(change)="onChangeOrganismeSendStat($event.value);
								preparerBanniereEligibiliteOrganisme($event.value, field.bannerContent);
								preparerBoutonEligibiliteOrganisme($event.value, eligibiliteAvvcContent.boutonLibelle)"
							[formControlName]="field.controlName" [attr.aria-labelledby]="field.htmlName + '-label'">
							<ng-container *ngFor="let choice of field.choices; last as last">
								<hr *ngIf="last" />
								<mat-radio-button [value]="choice.value">
									{{choice.label}}
								</mat-radio-button>
							</ng-container>
						</mat-radio-group>
					</ng-container>

					<dd1pnds-ng-link-v2
						*ngIf="isNonEligibleAvvc && eligibiliteAvvcContent.consulterServicePublic as bloc"
						class="ligne-bleue" matIconLeft="arrow_forward" [linkLabel]="bloc.contenu[0]"
						(linkClicked)="redirectToPage(bloc.lien, eventsStats.clicLienTrouverAide)">
					</dd1pnds-ng-link-v2>

					<ng-container *ngIf="isEligibleAvvc">
						<dd1pnds-ng-banner [bannerContent]="alerteEligibiliteAvvc" class="banniere-eligibilite-ok">
						</dd1pnds-ng-banner>

						<dd1pnds-ng-button backgroundColor="blue" [buttonContent]="boutonEligibiliteAvvc"
							(buttonClicked)="faireDemandeAvvc()" matIconNext="arrow_forward">
						</dd1pnds-ng-button>
					</ng-container>

				</form>
			</section>
		</section>

		<section class="avvc-partenaires">
			<h2>{{cartesPartenairesTitre}}</h2>
			<div class="avvc-liste-partenaires">
				<dd1pnds-ng-card *ngFor="let carte of cartesPartenaires" [cardContent]="carte"
					forceDisplayMobileDescription="true" forceDisplayMobileTexteLien="true"
					(cardClickedStat)="redirectToPage($event.redirect, $event.stat)">
				</dd1pnds-ng-card>
			</div>
		</section>
	</div>
</section>
